import {DiscordSDK} from '@discord/embedded-app-sdk'
import {SDKInit} from './SDKInit'
import {DiscordContentFrameMessageData, DiscordCommand, DiscordServerProfile, DiscordUserPermissions} from '../../../../../shared/DiscordActivityTypes'
import {ShareImageHelper} from '../utils/ShareImageHelper'
import {DiscordMountContentFrameListener} from './listeners/DiscordMountContentFrameListener'
import {DiscordMountContentFrameDispatcher} from './dispatchers/DiscordMountContentFrameDispatcher'
import {DiscordMountSDKEventListener} from './listeners/DiscordMountSDKEventListener'
import {DiscordMountSDKCommandDispatcher} from './dispatchers/DiscordMountSDKCommandDispatcher'

// Handles communication between the content frame and Discord client via the Discord SDK
export class DiscordMountController {
    discordSDK: DiscordSDK
    userDiscordAccessToken: string
    serverProfile: DiscordServerProfile
    userPermissions: DiscordUserPermissions
    isInitialLoad: boolean = true

    private sdkEventListener: DiscordMountSDKEventListener
    private sdkCommandDispatcher: DiscordMountSDKCommandDispatcher

    constructor() {
        void this.init()
    }

    async init() {
        const sdkData = await SDKInit.init()

        this.discordSDK = sdkData.discordSDK
        this.userDiscordAccessToken = sdkData.accessToken
        this.serverProfile = sdkData.serverProfile
        this.userPermissions = sdkData.userPermissions

        new DiscordMountContentFrameListener(this)
        this.sdkEventListener = new DiscordMountSDKEventListener(this.discordSDK)
        this.sdkCommandDispatcher = new DiscordMountSDKCommandDispatcher(this.discordSDK)

        this.sendReadyEvent()

        this.isInitialLoad = false
    }

    private sendReadyEvent() {
        DiscordMountContentFrameDispatcher.sendReadyEvent(this.discordSDK.instanceId, this.discordSDK.guildId, this.userDiscordAccessToken, this.serverProfile, this.userPermissions, this.discordSDK.referrerId, this.discordSDK.customId, this.isInitialLoad)
    }

    async handleMessageReceivedFromContentFrame(messageData: DiscordContentFrameMessageData) {
        const {messageId, event, subscription, command, data, args} = messageData

        let result: any
        switch(command) {
            case DiscordCommand.ContentFrameReady: {
                this.sendReadyEvent()
                break
            }
            case DiscordCommand.Subscribe: {
                this.sdkEventListener.subscribe(subscription)
                break
            }
            case DiscordCommand.Unsubscribe: {
                this.sdkEventListener.unsubscribe(subscription)
                break
            }
            case DiscordCommand.SetActivity: {
                result = await this.sdkCommandDispatcher.handleCommand('setActivity', [data as any])
                break
            }
            case DiscordCommand.OpenExternalLink: {
                result = await this.sdkCommandDispatcher.handleCommand('openExternalLink', [data as any])
                break
            }
            case DiscordCommand.InviteFriends: {
                result = await this.sdkCommandDispatcher.handleCommand('openInviteDialog', [])
                break
            }
            case DiscordCommand.Purchase: {
                result = await this.sdkCommandDispatcher.handleCommand('startPurchase', [data as any])
                break
            }
            case DiscordCommand.ShareMoment: {
                const discordUrl = await ShareImageHelper.uploadImageToDiscordCDN(messageData, this.userDiscordAccessToken)
                result = await this.sdkCommandDispatcher.handleCommand('openShareMomentDialog', [{mediaUrl: discordUrl} as any])
                break
            }
            case DiscordCommand.ShareActivityLink: {
                result = await this.sdkCommandDispatcher.handleCommand('shareLink', [data as any])
                break
            }
            default:
                break
        }
        DiscordMountContentFrameDispatcher.notifyCommandHasBeenHandled(messageId, event, subscription, command, result)
    }
}
